import React from 'react';
import { Helmet } from 'react-helmet-async';

const PolitiqueCookies: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Header */}
      <header className="bg-gradient-to-r from-blue-600 to-blue-900 text-white py-16 text-center mb-12 rounded-b-2xl">
        <h1 className="text-5xl font-bold mb-4">Politique Cookies</h1>
        <p className="text-xl opacity-95 max-w-2xl mx-auto">
          Comment nous utilisons les cookies sur TO THE ROAD
        </p>
      </header>

      <div className="max-w-4xl mx-auto px-4 pb-16">

        {/* Intro */}
        <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-blue-600 mb-10">
          <p className="mb-4 text-gray-900">
            Notre site <strong>www.totheroad.fr</strong> utilise des cookies pour améliorer votre
            expérience de navigation et analyser l'utilisation du site.
          </p>
          <p className="text-gray-900">
            Cette politique vous explique ce que sont les cookies, comment nous les utilisons et
            comment vous pouvez les gérer.
          </p>
        </div>

        {/* Section 1 */}
        <section className="bg-white p-8 rounded-lg shadow-md mb-8">
          <h2 className="text-3xl font-bold text-blue-900 mb-6 pb-4 border-b-4 border-blue-200">
            1. Qu'est-ce qu'un cookie ?
          </h2>
          <p className="mb-4 text-gray-900">
            Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette,
            smartphone) lors de la visite d'un site internet.
          </p>
          <p className="mb-6 text-gray-900">
            Il permet de collecter des informations relatives à votre navigation et de vous proposer
            des services adaptés à votre terminal.
          </p>

          <div className="bg-blue-50 border-l-4 border-blue-600 p-4 rounded-r-lg">
            <p className="font-bold text-blue-900 mb-3">Les cookies ne peuvent pas :</p>
            <ul className="list-disc list-inside space-y-2 text-gray-900">
              <li>Endommager votre appareil</li>
              <li>Installer des virus</li>
              <li>Accéder à vos fichiers personnels</li>
            </ul>
          </div>
        </section>

        {/* Section 2 */}
        <section className="bg-white p-8 rounded-lg shadow-md mb-8">
          <h2 className="text-3xl font-bold text-blue-900 mb-6 pb-4 border-b-4 border-blue-200">
            2. Types de cookies utilisés
          </h2>
          <p className="mb-6 text-gray-900">
            Notre site utilise uniquement les types de cookies suivants :
          </p>

          <h3 className="text-xl font-bold text-blue-600 mb-4">Cookies strictement nécessaires</h3>
          <div className="bg-blue-50 border-l-4 border-blue-600 p-5 rounded-r-lg mb-6">
            <p className="mb-2 text-gray-900"><strong>Finalité :</strong> Assurer le bon fonctionnement du site et la sécurité de votre navigation</p>
            <p className="mb-2 text-gray-900"><strong>Exemples :</strong></p>
            <ul className="list-disc list-inside space-y-1 text-gray-900 ml-2 mb-3">
              <li>Cookies de session (maintien de la connexion pendant la visite)</li>
              <li>Cookies de sécurité (protection contre les attaques CSRF)</li>
              <li>Mémorisation de vos choix de cookies</li>
            </ul>
            <p className="mb-1 text-gray-900"><strong>Base juridique :</strong> Intérêt légitime (Article 6.1.f RGPD)</p>
            <p className="mb-1 text-gray-900"><strong>Consentement requis :</strong> Non (indispensables au fonctionnement)</p>
            <p className="text-gray-900"><strong>Durée :</strong> Session ou maximum 13 mois</p>
          </div>

          <h3 className="text-xl font-bold text-blue-600 mb-4">Cookies d'analyse (Google Analytics)</h3>
          <div className="bg-blue-50 border-l-4 border-blue-600 p-5 rounded-r-lg">
            <p className="mb-2 text-gray-900"><strong>Finalité :</strong> Analyser l'utilisation du site pour améliorer nos services</p>
            <p className="mb-2 text-gray-900"><strong>Données collectées :</strong></p>
            <ul className="list-disc list-inside space-y-1 text-gray-900 ml-2 mb-3">
              <li>Pages visitées</li>
              <li>Durée de visite</li>
              <li>Parcours de navigation</li>
              <li>Type d'appareil et navigateur</li>
            </ul>
            <p className="mb-1 text-gray-900"><strong>Base juridique :</strong> Consentement (Article 6.1.a RGPD)</p>
            <p className="mb-1 text-gray-900"><strong>Consentement requis :</strong> Oui</p>
            <p className="mb-1 text-gray-900"><strong>Durée :</strong> Maximum 13 mois</p>
            <p className="mb-1 text-gray-900"><strong>Anonymisation :</strong> Les adresses IP sont anonymisées</p>
            <p className="text-gray-900"><strong>Fournisseur :</strong> Google Ireland Limited</p>
          </div>
        </section>

        {/* Section 3 */}
        <section className="bg-white p-8 rounded-lg shadow-md mb-8">
          <h2 className="text-3xl font-bold text-blue-900 mb-6 pb-4 border-b-4 border-blue-200">
            3. Liste détaillée des cookies
          </h2>

          <div className="overflow-x-auto">
            <table className="w-full border-collapse rounded-lg overflow-hidden shadow-sm">
              <thead>
                <tr className="bg-gradient-to-r from-blue-600 to-blue-900 text-white">
                  <th className="px-4 py-4 text-left font-bold">Nom du cookie</th>
                  <th className="px-4 py-4 text-left font-bold">Type</th>
                  <th className="px-4 py-4 text-left font-bold">Finalité</th>
                  <th className="px-4 py-4 text-left font-bold">Durée</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="px-4 py-4 text-gray-900 font-medium">cookie_consent</td>
                  <td className="px-4 py-4">
                    <span className="inline-block bg-blue-100 text-blue-900 px-3 py-1 rounded-full text-xs font-semibold">
                      Nécessaire
                    </span>
                  </td>
                  <td className="px-4 py-4 text-gray-900">Mémoriser vos choix de cookies</td>
                  <td className="px-4 py-4 text-gray-900">13 mois</td>
                </tr>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <td className="px-4 py-4 text-gray-900 font-medium">_ga</td>
                  <td className="px-4 py-4">
                    <span className="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-semibold">
                      Analytique
                    </span>
                  </td>
                  <td className="px-4 py-4 text-gray-900">Distinguer les utilisateurs (Google Analytics)</td>
                  <td className="px-4 py-4 text-gray-900">13 mois</td>
                </tr>
                <tr>
                  <td className="px-4 py-4 text-gray-900 font-medium">_gid</td>
                  <td className="px-4 py-4">
                    <span className="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-semibold">
                      Analytique
                    </span>
                  </td>
                  <td className="px-4 py-4 text-gray-900">Distinguer les utilisateurs (Google Analytics)</td>
                  <td className="px-4 py-4 text-gray-900">24 heures</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Section 4 */}
        <section className="bg-white p-8 rounded-lg shadow-md mb-8">
          <h2 className="text-3xl font-bold text-blue-900 mb-6 pb-4 border-b-4 border-blue-200">
            4. Durée de conservation
          </h2>
          <p className="mb-6 text-gray-900">
            Les cookies sont conservés sur votre appareil pendant les durées suivantes :
          </p>

          <div className="overflow-x-auto mb-6">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-blue-50">
                  <th className="px-5 py-4 text-left border-b-2 border-blue-600 font-bold text-blue-900 w-1/2">
                    Type de cookie
                  </th>
                  <th className="px-5 py-4 text-left border-b-2 border-blue-600 font-bold text-blue-900">
                    Durée maximale
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="px-5 py-4">
                    <span className="inline-block bg-blue-100 text-blue-900 px-3 py-1 rounded-full text-sm font-semibold">
                      Strictement nécessaires
                    </span>
                  </td>
                  <td className="px-5 py-4 text-gray-900">
                    <strong>Session</strong> ou <strong>13 mois</strong>
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-5 py-4">
                    <span className="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-semibold">
                      Analyse et performance
                    </span>
                  </td>
                  <td className="px-5 py-4 text-gray-900">
                    <strong>13 mois</strong> (recommandation CNIL)
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="bg-blue-50 border-l-4 border-blue-600 p-4 rounded-r-lg">
            <p className="font-bold text-blue-900 mb-2">Renouvellement du consentement</p>
            <p className="text-gray-900">
              Votre consentement pour les cookies analytiques est valable pour une durée de{' '}
              <strong>13 mois</strong>. Passé ce délai, nous vous demanderons à nouveau votre accord.
            </p>
          </div>
        </section>

        {/* Section 5 */}
        <section className="bg-white p-8 rounded-lg shadow-md mb-8">
          <h2 className="text-3xl font-bold text-blue-900 mb-6 pb-4 border-b-4 border-blue-200">
            5. Comment gérer vos préférences ?
          </h2>

          <h3 className="text-xl font-bold text-blue-600 mb-4">Via notre bandeau de consentement</h3>
          <p className="mb-4 text-gray-900">
            Lors de votre première visite, un bandeau de consentement s'affiche vous permettant de :
          </p>
          <ul className="list-disc list-inside space-y-2 mb-6 text-gray-900">
            <li><strong>Tout accepter</strong> : Accepter tous les cookies</li>
            <li><strong>Personnaliser</strong> : Choisir quels cookies accepter</li>
            <li><strong>Tout refuser</strong> : Refuser les cookies non-nécessaires</li>
          </ul>

          <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-r-lg mb-8">
            <p className="font-bold text-green-900 mb-2">Modifier vos préférences à tout moment</p>
            <p className="text-gray-900">
              Vous pouvez changer d'avis en cliquant sur le bouton <strong>"Gérer les cookies"</strong>{' '}
              présent en bas de chaque page.
            </p>
          </div>

          <h3 className="text-xl font-bold text-blue-600 mb-4">Via les paramètres de votre navigateur</h3>
          <p className="mb-6 text-gray-900">Tous les navigateurs vous permettent de gérer les cookies :</p>

          <div className="space-y-4 mb-8">
            <div className="bg-gray-50 p-5 rounded-lg border-l-3 border-blue-600 border-l-4">
              <h4 className="font-bold text-blue-900 mb-2">Google Chrome</h4>
              <p className="text-gray-900 text-sm mb-2">
                <strong>Paramètres</strong> → <strong>Confidentialité et sécurité</strong> → <strong>Cookies</strong>
              </p>
              <a
                href="https://support.google.com/chrome/answer/95647"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline text-sm"
              >
                → Guide complet Chrome
              </a>
            </div>

            <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-600">
              <h4 className="font-bold text-blue-900 mb-2">Mozilla Firefox</h4>
              <p className="text-gray-900 text-sm mb-2">
                <strong>Options</strong> → <strong>Vie privée et sécurité</strong> → <strong>Cookies</strong>
              </p>
              <a
                href="https://support.mozilla.org/fr/kb/cookies-informations-sites-enregistrent"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline text-sm"
              >
                → Guide complet Firefox
              </a>
            </div>

            <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-600">
              <h4 className="font-bold text-blue-900 mb-2">Safari (Mac/iOS)</h4>
              <p className="text-gray-900 text-sm mb-2">
                <strong>Préférences</strong> → <strong>Confidentialité</strong> → <strong>Cookies</strong>
              </p>
              <a
                href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline text-sm"
              >
                → Guide complet Safari
              </a>
            </div>

            <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-600">
              <h4 className="font-bold text-blue-900 mb-2">Microsoft Edge</h4>
              <p className="text-gray-900 text-sm mb-2">
                <strong>Paramètres</strong> → <strong>Cookies</strong>
              </p>
              <a
                href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline text-sm"
              >
                → Guide complet Edge
              </a>
            </div>
          </div>

          <h3 className="text-xl font-bold text-blue-600 mb-4">Désactiver Google Analytics</h3>
          <div className="bg-blue-50 border-l-4 border-blue-600 p-4 rounded-r-lg">
            <p className="text-gray-900 mb-3">
              Pour empêcher Google Analytics de collecter vos données sur tous les sites web, vous
              pouvez installer le <strong>module complémentaire officiel</strong> :
            </p>
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline font-bold"
            >
              → Télécharger le module de désactivation Google Analytics
            </a>
          </div>
        </section>

        {/* Section 6 */}
        <section className="bg-white p-8 rounded-lg shadow-md mb-8">
          <h2 className="text-3xl font-bold text-blue-900 mb-6 pb-4 border-b-4 border-blue-200">
            6. Google Analytics - Détails
          </h2>

          <div className="bg-blue-50 border-l-4 border-blue-600 p-5 rounded-r-lg">
            <p className="mb-2 text-gray-900">
              <strong>Fournisseur :</strong> Google Ireland Limited, Gordon House, Barrow Street,
              Dublin 4, Irlande
            </p>
            <p className="mb-2 text-gray-900">
              <strong>Finalité :</strong> Analyse d'audience et mesure de performance
            </p>
            <p className="mb-2 text-gray-900">
              <strong>Politique de confidentialité :</strong>{' '}
              <a
                href="https://policies.google.com/privacy?hl=fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                policies.google.com/privacy
              </a>
            </p>
            <p className="mb-2 text-gray-900">
              <strong>Transfert de données :</strong> Les données peuvent être transférées aux États-Unis
            </p>
            <p className="mb-2 text-gray-900">
              <strong>Garanties :</strong> Clauses contractuelles types (CCT) de la Commission Européenne
            </p>
            <p className="text-gray-900">
              <strong>Anonymisation IP :</strong> Activée pour protéger votre vie privée
            </p>
          </div>
        </section>

        {/* Section 7 */}
        <section className="bg-white p-8 rounded-lg shadow-md mb-8">
          <h2 className="text-3xl font-bold text-blue-900 mb-6 pb-4 border-b-4 border-blue-200">
            7. Conséquences du refus des cookies
          </h2>

          <h3 className="text-xl font-bold text-blue-600 mb-4">Cookies strictement nécessaires</h3>
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg mb-6">
            <p className="font-bold text-yellow-800">
              Ces cookies ne peuvent pas être refusés car ils sont indispensables au fonctionnement
              du site.
            </p>
          </div>

          <h3 className="text-xl font-bold text-blue-600 mb-4">Cookies d'analyse</h3>
          <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-r-lg">
            <p className="font-bold text-green-900 mb-3">Impact si refusés :</p>
            <ul className="list-disc list-inside space-y-2 text-gray-900">
              <li>Aucun impact sur votre navigation</li>
              <li>Le site fonctionne normalement</li>
              <li>Nous ne pourrons pas améliorer le site selon vos usages</li>
            </ul>
          </div>
        </section>

        {/* Contact box */}
        <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-blue-600 mb-8">
          <h3 className="text-2xl font-bold text-blue-900 mb-4">Questions sur les cookies ?</h3>
          <p className="mb-4 text-gray-900">
            Pour toute question concernant notre utilisation des cookies, n'hésitez pas à nous
            contacter :
          </p>
          <p className="mb-2 text-gray-900">
            <strong>Email :</strong>{' '}
            <a href="mailto:contact@totheroad.fr" className="text-blue-600 hover:underline">
              contact@totheroad.fr
            </a>
          </p>
          <p className="text-gray-900">
            <strong>Adresse :</strong> TO THE ROAD — 61 rue de Lyon, 75012 Paris, France
          </p>
        </div>

        {/* Documents complémentaires */}
        <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-r-lg">
          <p className="font-bold text-green-900 mb-3">Documents complémentaires :</p>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <a href="/mentions-legales" className="text-blue-600 hover:underline">
                Mentions légales
              </a>
            </li>
            <li>
              <a href="/politique-confidentialite" className="text-blue-600 hover:underline">
                Politique de confidentialité
              </a>
            </li>
            <li>
              <a
                href="https://www.cnil.fr/fr/cookies-et-autres-traceurs"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                En savoir plus sur les cookies (CNIL)
              </a>
            </li>
          </ul>
        </div>

      </div>

      {/* Footer */}
      <footer className="bg-gray-100 border-t border-gray-300 py-10 text-center text-gray-600 text-sm">
        <p className="mb-1">© 2026 TO THE ROAD - Tous droits réservés</p>
        <p>Dernière mise à jour : 21 mars 2026</p>
      </footer>

    </div>
  );
};

export default PolitiqueCookies;
